import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse, IServicePermissions } from '../../model';
import {
  IResourceGroupCreate,
  IResourceGroupDelete,
  IResourceObjectCreate,
  IResourceObjectUpdate,
  RbacAdminPermObjectKey,
} from '../../model/api-modules';
import {
  ADMIN_PERMISSION_PROXY_PREFIX,
  ADMIN_RBAC_PROXY,
  ADMIN_PREFIX,
} from '../config';

const getUrl = (path: string) => {
  if (window.location.pathname.includes('/support-permission')) {
    const postfix =
      path +
      (path.includes('?')
        ? '&permKey=permissionManage'
        : '?permKey=permissionManage');
    return `${ADMIN_RBAC_PROXY}${postfix}`;
  }
  return `${ADMIN_PERMISSION_PROXY_PREFIX}${path}`;
};

// 获取服务权限列表-平铺-admin
export const getAdminServicePermissionsList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/GetObjectList');
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IServicePermissions>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

export const getAdminSupportServicePermissionsList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_RBAC_PROXY}/GetObjectList?permKey=${RbacAdminPermObjectKey.OrganizationRoleManage}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IServicePermissions>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 资源组-资源列表-树
export const getResourceTreeList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/GetPermObject');
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IResourceGroupCreate>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: getResourceTreeList', error);
      return false;
    }
  });

// 资源组-group添加
export const createResourceGroup = (body: IResourceGroupCreate) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/AddPermObjectGroup');
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: createResourceGroup', error);
      return false;
    }
  });

// 资源组-group修改
// export const updateResourceGroup = (objectGroupId:number,body: IResourceGroupCreate) =>
export const updateResourceGroup = (body: IResourceGroupCreate) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/ModifyPermObjectGroup');
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: updateResourceGroup', error);
      return false;
    }
  });

// 资源组-group删除
export const deleteResourceGroup = (objectGroupId: Array<number>) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/DeletePermObjectGroup');
      const response = await api.commonRequest('DELETE', url, {
        objectGroupId,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: deleteResourceGroup', error);
      return error?.apiError;
    }
  });

// 资源对象-object添加
export const createResourceObject = (body: IResourceObjectCreate) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/AddPermObject');
      const response = await api.commonRequest('POST', url, { data: [body] });
      const res = await parsedResponse<IResourceGroupDelete>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: createResourceObject', error);
      return false;
    }
  });
// 资源对象-object删除
export const deleteResourceObject = (objectId: Array<number>) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/DeletePermObject');
      const response = await api.commonRequest('DELETE', url, { objectId });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: deleteResourceObject', error);
      return false;
    }
  });
// 资源对象-object修改
export const updateResourceObject = (body: IResourceObjectUpdate) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = getUrl('/ModifyPermObject');
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IResourceGroupDelete>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: updateResourceObject', error);
      return false;
    }
  });

// 批量添加资源
export const batchCreateResource = (body: any) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/scripts/permission`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: createResourceObject', error);
      return false;
    }
  });
